import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconLateralMovementProps } from './IconLateralMovement.types'
import * as Styled from './styles/IconLateralMovement.style'

import { nonThemeableRules } from '../../ruleSet'

const IconLateralMovement: FC<IconLateralMovementProps> = ({
  size = nonThemeableRules.defaultSize as number as IconLateralMovementProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconLateralMovementProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path d='M14.5 17c-1.125.625-1.5 2.125-.309 3.25L15.5 21.5' vectorEffect='non-scaling-stroke' />
          <path
            d='M3.5 15.5c.125 1.75 1.055 2.738 1.5 3 2.75 1.625 7.566 0 11 0 2.5 0 4 .875 5.5 3M11.29 2.824c-2.548-.367-3.087-.394-3.778-.355-.692.035-1.535-.125-2.532 1.539-1 1.664-1.605 2.61-1.84 3.21-.23.606-.413 2.891-.515 3.56-.102.671.375.921 1.219 1.042l6.011.875'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M4.344 11.895c-.14.988-.067.472-.14.96-.095.649-.224.75-1.028.625-.805-.125-.903-.25-.809-.894l.258-1.809m8.223-4.839c-.528-.079-2.02-.262-3.356-.485C6.16 5.227 6.27 4.18 6.566 3.34l.23-.793M6.54 7.883s.093-1.477-2.454-1.477'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M3.281 7.832c.25.25 1.563.691 3.258.05m4.751-5.058c2.542.371 3.065.5 3.718.727.652.226 1.508.324 1.992 2.199.484 1.875.8 2.957.852 3.602.05.644-.418 2.886-.516 3.558-.094.672-.625.777-1.465.652l-6.012-.874'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M15.375 13.488c-.14.992-.066.473-.14.961-.094.649 0 .778.812.895.808.117.933.02 1.027-.625l.262-1.809m-1.672-9.043c-.004.266.004.531.027.793.047.89-.14 1.922-1.488 1.762-1.344-.16-2.828-.406-3.355-.484m6.961 3.996c-.309.164-1.696.218-3.141-.875m.004-.016s.34-1.441 2.773-.711'
            vectorEffect='non-scaling-stroke'
          />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconLateralMovement
